import React from "react";
import { findBlockIcon } from "../constants/iconCatalog";
import { getEmojiUrl } from "../utils/helpers";
import { jsx as _jsx } from "react/jsx-runtime";
export default function BlockIcon(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? {} : _ref$content,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    className = _ref.className;
  var size = content.size || "40px";
  var color = style.color || "#101828";
  var iconDef = content.iconName ? findBlockIcon(content.iconName) : null;
  if (iconDef) {
    return /*#__PURE__*/_jsx("svg", {
      className: className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: color,
      strokeWidth: 1.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: {
        display: "inline-block",
        verticalAlign: "middle"
      },
      "aria-hidden": "true",
      children: (iconDef.paths || []).map(function (d, index) {
        return /*#__PURE__*/_jsx("path", {
          d: d
        }, index);
      })
    });
  }
  var symbol = content.symbol || "★";
  var emojiUrl = getEmojiUrl(symbol);
  if (emojiUrl) {
    return /*#__PURE__*/_jsx("img", {
      className: className,
      src: emojiUrl,
      alt: symbol,
      style: {
        width: size,
        height: size,
        verticalAlign: "middle",
        display: "inline-block"
      }
    });
  }
  return /*#__PURE__*/_jsx("span", {
    className: className,
    style: {
      fontSize: size,
      lineHeight: 1,
      color: color,
      display: "inline-block"
    },
    children: symbol
  });
}